import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ChevronDown({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M5 9.41424L6.41421 8.00003L11.7071 13.2929L17 8.00003L18.4142 9.41424L11.7071 16.1214L5 9.41424Z"
        fill={iconColor}
      />
    </Svg>
  );
}
